
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2qdw9_1umh7_9",
  "refresh": "awsui_refresh_2qdw9_1umh7_45",
  "root-no-actions": "awsui_root-no-actions_2qdw9_1umh7_45",
  "root-variant-h2": "awsui_root-variant-h2_2qdw9_1umh7_48",
  "root-variant-h3": "awsui_root-variant-h3_2qdw9_1umh7_48",
  "root-has-description": "awsui_root-has-description_2qdw9_1umh7_48",
  "root-variant-h1": "awsui_root-variant-h1_2qdw9_1umh7_57",
  "main": "awsui_main_2qdw9_1umh7_67",
  "no-wrap": "awsui_no-wrap_2qdw9_1umh7_77",
  "main-variant-h1": "awsui_main-variant-h1_2qdw9_1umh7_83",
  "actions": "awsui_actions_2qdw9_1umh7_91",
  "actions-centered": "awsui_actions-centered_2qdw9_1umh7_96",
  "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_1umh7_99",
  "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_1umh7_103",
  "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_1umh7_107",
  "title": "awsui_title_2qdw9_1umh7_123",
  "title-variant-h1": "awsui_title-variant-h1_2qdw9_1umh7_128",
  "title-variant-h2": "awsui_title-variant-h2_2qdw9_1umh7_135",
  "title-variant-h3": "awsui_title-variant-h3_2qdw9_1umh7_141",
  "title-in-expandable-section": "awsui_title-in-expandable-section_2qdw9_1umh7_154",
  "virtual-space": "awsui_virtual-space_2qdw9_1umh7_169",
  "info": "awsui_info_2qdw9_1umh7_175",
  "description": "awsui_description_2qdw9_1umh7_179",
  "description-variant-h1": "awsui_description-variant-h1_2qdw9_1umh7_186",
  "description-variant-h2": "awsui_description-variant-h2_2qdw9_1umh7_190",
  "description-variant-h3": "awsui_description-variant-h3_2qdw9_1umh7_197",
  "heading": "awsui_heading_2qdw9_1umh7_208",
  "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_1umh7_233",
  "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_1umh7_238",
  "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_1umh7_243",
  "heading-text": "awsui_heading-text_2qdw9_1umh7_249",
  "heading-text-variant-h1": "awsui_heading-text-variant-h1_2qdw9_1umh7_252",
  "heading-text-variant-h2": "awsui_heading-text-variant-h2_2qdw9_1umh7_261",
  "heading-text-variant-h3": "awsui_heading-text-variant-h3_2qdw9_1umh7_270",
  "counter": "awsui_counter_2qdw9_1umh7_280"
};
  